import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import { client } from '../../utils/client'
import { useDispatch } from 'react-redux'
import { setLoading, showSnackbar } from '../../actions/pageActions'
import { IconButton } from '@mui/material'
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog'
import { USER_PATH } from '../../constants/endpointsConstants'

const DeleteUser = ({ user, onDelete }) => {
  const dispatch = useDispatch()

  const deleteUser = () => {
    dispatch(setLoading(true))
    client
      .delete(`${USER_PATH}/${user.id}`)
      .then(() => {
        dispatch(setLoading(false))
        dispatch(showSnackbar('Usuario eliminado', 'success'))
        onDelete(user.id)
      })
      .catch(() => {
        dispatch(setLoading(false))
        dispatch(showSnackbar('Error al eliminar el usuario', 'error'))
      })
  }
  return (
    <ConfirmDialog
      buttonOpen={
        <IconButton color="error">
          <DeleteIcon />
        </IconButton>
      }
      title="Eliminar usuario"
      body={`¿Deseas eliminar a "${user.name} ${user.lastNameFather} ${user.lastNameMother}"?`}
      onConfirm={deleteUser}
    />
  )
}

export default DeleteUser
